/**
 * Created by caoshi on 2017/9/4.
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: "",
    token: null,
    company: "",
    company_id: "",
    companyList: "",
    // 将来之星回显
    futureItem: {}
  },
  mutations: {
    updateToken(state, newToken) {
      state.token = newToken;
    },
    updateUserInfo(state, newUserInfo) {
      state.user = newUserInfo;
    },
    updateCompanyList(state, companyList) {
      state.companyList = companyList;
    },
    updateCompany(state, company) {
      state.company = company;
    },
    updateCompanyId(state, curCompanyId) {
      state.company_id = curCompanyId;
    },
    saveFutureItem(state, payload) {
      state.futureItem = payload;
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js